import { styled } from 'styled-components';

const Page = styled.div`
  width: 100%;
  height: 100%;
  transition: 0.3s;
  background: #F7F7F7;
  display: flex;
  align-items: center;
  overflow: hidden;
  flex-direction: column;
`;

export default Page;
